import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { Customer } from 'app/models'
import { CustomerService } from 'app/services'

import { ColorRenderComponent } from 'app/components/cell/render/color.render.component'
import { ToggleRenderComponent } from 'app/components/cell/render/toggle.render.component'
import { PasswordRenderComponent } from 'app/components/cell/render/password.render.component'

import { ColorEditorComponent } from 'app/components/cell/editor/color.editor.component'
import { PasswordEditorComponent } from 'app/components/cell/editor/password.editor.component';
import { ToggleEditorComponent } from 'app/components/cell/editor/toggle.editor.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmDialog } from 'app/components/dialog/confirm.dialog';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
    selector: 'table-customer',
    template: `<ng2-smart-table 
                [settings]="settings"
                [source]="source"
                (createConfirm)="handleAdd($event)"
                (editConfirm)="handleEdit($event)"
                (deleteConfirm)="handleDelete($event)"
            ></ng2-smart-table>`,
    styleUrls: ['./table.customer.component.css']
})
export class TableCustomerComponent implements OnInit {

    public source: LocalDataSource
    public settings = {
        hideHeader: false,
        add: {
            confirmCreate: true,
            addButtonContent: `
            <a mat-button class="nav-link active product-add">
                <i class="material-icons">add_circle_outline</i>
                <div class="ripple-container"></div>
            </a>
            `,
            createButtonContent: `
            <i class="material-icons">check_circle_outline</i>
            <div class="ripple-container"></div>
            `,
            cancelButtonContent: `
            <i class="material-icons">highlight_off</i>
            <div class="ripple-container"></div>
            `
        },
        edit: {
            confirmSave: true,
            editButtonContent: `
            <i class="material-icons">play_circle_outline</i>
            <div class="ripple-container"></div>
            `,
            saveButtonContent: `
            <i class="material-icons">check_circle_outline</i>
            <div class="ripple-container"></div>
            `,
            cancelButtonContent: `
            <i class="material-icons">highlight_off</i>
            <div class="ripple-container"></div>
            `
        },
        delete: {
            confirmDelete: true,
            deleteButtonContent: `
            <i class="material-icons">remove_circle_outline</i>
            <div class="ripple-container"></div>
            `
        },
        columns: {
            first_name: {
                title: 'Prénom'
            },
            last_name: {
                title: 'Nom'
            },
            address: {
                title: 'Adresse'
            },
            postal_code: {
                title: 'Code postal'
            },
            city: {
                title: 'Ville'
            },
            phone: {
                title: 'Téléphone'
            },
            email: {
                title: 'e-mail'
            },
            comment: {
                title: 'Commentaire'
            },
        }
    }
    
    @Input()
    public customers: Array<Customer>

    @Output()
    public onCreate: EventEmitter<any> = new EventEmitter
    @Output()
    public onEdit: EventEmitter<any> = new EventEmitter
    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter

    constructor(
        private _CustomerService: CustomerService,
        private _LoaderService: NgxUiLoaderService,
        private _Dialog: MatDialog,
        private _ToasterService: ToastrService
    ) { }


    public ngOnInit(): void {
        this.source = new LocalDataSource(this.customers)
    }

    public async handleAdd($event): Promise<void> {
        try {
            this._LoaderService.start()
            let customer = {...$event.newData}
            let res = await this._CustomerService.add(customer)
            $event.newData.customer_id = res.lastInsertId
            await $event.confirm.resolve($event.newData)
            this.onCreate.emit($event.newData)
            this._LoaderService.stop()
            this._ToasterService.success("Ajout du client effectué.")
            return Promise.resolve()
        } catch (error) {
            console.error("TableCustomerComponent::handleAdd", error)
            this._LoaderService.stop()
            if (error.json().code === "0x1007") this._ToasterService.warning(`Vous n'êtes pas autorisé à effectuer cette action`)
            else this._ToasterService.error("Erreur lors de l'ajout du client.")
            return Promise.reject(error)
        }
    }

    public async handleEdit($event): Promise<void> {
        try {
            this._LoaderService.start()
            let customer = {...$event.newData}
            await this._CustomerService.edit($event.data.customer_id, customer)
            await $event.confirm.resolve()
            this.onEdit.emit($event.newData)
            this._LoaderService.stop()
            this._ToasterService.success("Modification du client effectué.")
            return Promise.resolve()
        } catch (error) {
            console.error("TableCustomerComponent::handleEdit", error)
            this._LoaderService.stop()
            if (error.json().code === "0x1007") this._ToasterService.warning(`Vous n'êtes pas autorisé à effectuer cette action`)
            else this._ToasterService.error("Erreur lros de la modification du client.")
            return Promise.reject(error)
        }
    }
    
    public async handleDelete($event): Promise<void> {
        try {
            let dialog = this._Dialog.open(ConfirmDialog, {width: '400px'})
            let result = await dialog.afterClosed().toPromise()
            if (!result) return
            this._LoaderService.start()
            await this._CustomerService.delete($event.data.customer_id)
            await $event.confirm.resolve()
            this.onDelete.emit($event.index)
            this._LoaderService.stop()
            this._ToasterService.success("Suppression du client effectué.")
            return Promise.resolve()
        } catch (error) {
            console.error("TableCustomerComponent::handleDelete", error)
            this._LoaderService.stop()
            if (error.json().code === "0x1007") this._ToasterService.warning(`Vous n'êtes pas autorisé à effectuer cette action`)
            else this._ToasterService.error("Erreur lors de la suppression du client.")
            return Promise.reject(error)
        }
    }
    
}